import ApiClient from './ApiClient';

const getAttachments = (key, opts) => ApiClient.instance.get({ path: `/api/attachments/${encodeURIComponent(key)}`, params: (opts || {}) });

const getAttachmentContent = (key) => ApiClient.instance.getBlob({ path: `/api/attachments/${encodeURIComponent(key)}/content` });

const uploadAttachment = (key, fieldName, arrayName, arrayIndex, fileName, data) => ApiClient.instance.post({
  path: `/api/attachments/${encodeURIComponent(key)}`,
  body: {
    fieldName,
    arrayName,
    arrayIndex,
    fileName,
    data,
  },
});

const deleteAttachment = (key) => ApiClient.instance.del(({ path: `/api/attachments/${encodeURIComponent(key)}` }));

export {
  getAttachmentContent, getAttachments, uploadAttachment, deleteAttachment,
};
